import type { FreelancerCompetenciesInformationPageLocales } from '../types';

const freelancerCompetenciesInformationPageLocales: FreelancerCompetenciesInformationPageLocales =
  {
    competences: 'Competenties',
    CompetencesAdded: 'Competenties opgeslagen',
    competencesRequired: 'Selecteer ten minste 1 competentie.',
    licenses: 'Rijbewijzen',
    needMoreInformation:
      'We hebben nog iets meer informatie over je nodig om de aanmelding compleet te maken.',
    ownsDriverLicense: 'Ik ben in bezit van een rijbewijs.',
    ownsStintLicense: 'Ik ben in bezit van een stintbewijs.',
    selectCompetences: 'Selecteer Competenties',
    title: 'Persoonlijke Gegevens',
  };

export default freelancerCompetenciesInformationPageLocales;
